import { gql } from '__generated__';

export default gql(`
  query GetExportProfiles($project_id: ID!, $type: String!, $event_id: ID) {
    project(id: $project_id,) {
      id
      export_profiles(type: $type, event_id: $event_id) {
        id
        title
        column_titles
        event {
          id
          title
        }
        created_at
      }
      default_export_columns(type: $type, event_id: $event_id) {
        id
        title
      }
    }
  }
`);
